export default __webpack_public_path__ + "static/blinkingarsh-eaa0e8fd9fb9f1aa55bbca10893de271.gif";